import React, { useMemo } from 'react'
import { RECEPTOR_TYPE } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import { useListDirectoryScanSettings } from 'src/pages/Evidence/evidence.hooks'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'
import { getReceptorFilterValues } from './FilterDropdown.helpers'
import { LoadingFilterDropdown } from './FilterDropdown.components'
import { SourceFilterValues } from './SourceFilterDropdown'

export const DocumentScanFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { data: directoryScanSettings, isLoading: isDirectoryLoading } =
      useListDirectoryScanSettings()

    const folderScanFilterValues = useMemo(
      () =>
        directoryScanSettings?.getSettingsList().map((setting) => ({
          value: setting.getId(),
          label: setting.getName() || setting.getRootPath(),
        })) || [],
      [directoryScanSettings],
    )

    const filterValues = useMemo(
      () => [
        {
          value: SourceFilterValues.RECEPTOR,
          label: 'Receptor',
          nestedFilter: {
            filterParam: FilterParam.RECEPTOR,
            filterValues: getReceptorFilterValues(RECEPTOR_TYPE.RECEPTOR),
          },
        },
        {
          value: SourceFilterValues.DOCUMENT_MANAGEMENT_SYSTEM,
          label: 'Document Management System',
          nestedFilter: {
            filterParam: FilterParam.DOCUMENT_MANAGEMENT_SYSTEM,
            filterValues: getReceptorFilterValues(
              RECEPTOR_TYPE.COLLABORATION_SYSTEM,
            ),
          },
        },
        {
          value: SourceFilterValues.WORKFLOW_MANAGEMENT_SYSTEM,
          label: 'Workflow Management System',
          nestedFilter: {
            filterParam: FilterParam.WORKFLOW_MANAGEMENT_SYSTEM,
            filterValues: getReceptorFilterValues(
              RECEPTOR_TYPE.WORKFLOW_PLATFORM,
            ),
          },
        },
        {
          value: 'folder_scan',
          label: 'Folder Scan',
          nestedFilter: {
            filterParam: FilterParam.FOLDER_SCAN,
            filterValues: folderScanFilterValues,
          },
        },
      ],
      [folderScanFilterValues],
    )

    if (isDirectoryLoading) {
      return (
        <LoadingFilterDropdown
          filterName={FilterName.SOURCE}
          isNested={isNested}
        />
      )
    }

    return (
      <FilterDropdown
        filterParam={FilterParam.SOURCE}
        filterName={FilterName.SOURCE}
        filterValues={filterValues}
        hasNested
        includeParentFilter={true}
        isNested={isNested}
      />
    )
  },
)
